import { ResolveState } from '../../../common';
import { ErrorResult } from '../../../upgrade/models/error-result';
import { Logger } from '../../utils/logger';

/**
 * Updater for css-syntax-error warning.
 */
export class CssSyntaxErrorUpdater {
    /**
     * the update function.
     * @param fileData the file data.
     * @param error the error object.
     * @returns the updated file data.
     */
    public update(fileData: string, error: ErrorResult): string {
        if (!fileData) {
            Logger.error(`Cannot find file data`);
        }

        const result = this.regexFixer(fileData);

        error.resolved = ResolveState.Resolved;
        return result;
    }

    /**
     * the update function.
     * @param inputString the input file data string.
     * @returns the updated file data string.
     */
    private regexFixer(inputString): string {
        inputString = inputString.replace(/:host\s*>>>\s*\./g, ':host::ng-deep .');
        return inputString.replace(/:host\s*>>>\s*/g, ':host::');
    }
}
